import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-46eb6c6b"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "sel-main"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 订单记录 ");

const _hoisted_4 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_top_title = _resolveComponent("top-title");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_top_title, {
    onBack: $setup.back,
    title: "支付数据"
  }, null, 8, ["onBack"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[0] || (_cache[0] = $event => $setup.router.push({
      'name': 'CollectUserOrder'
    }))
  }, [_hoisted_3, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_4)])])]);
}